export default __webpack_public_path__ + "static/media/badge_hour_flare.9533ae28.png";